import { PII_SERVICE_URI } from "env";
import { proxyFetch } from "../utils";
import TiliaAPIError from "api/TiliaAPIError";

export { default as useSubmitKYC } from "./useSubmitKYC";
export { default as usePollKYCStatus } from "./usePollKYCStatus";
export { default as useAccountKYCStatus } from "./useAccountKYCStatus";

const piiProxy = proxyFetch(PII_SERVICE_URI);

export const submitKYC = async (ctx, formData) => {
  const response = await piiProxy(ctx, "/v2/kyc", "POST", formData);
  if (!response.ok) {
    const data = await response.json();
    const info = {
      message: data?.payload?.error || "",
      errorCodes: data?.codes || [],
    };
    throw new TiliaAPIError(response, info);
  }
  return response.json();
};
